import { types } from 'mobx-state-tree';
import Framework from '@greenville/framework';
import * as constants from '../../../common/constants';

/* eslint-disable no-param-reassign */
const AiAdminExecutionLogsModel = types
  .model('AiAdminExecutionLogsModel', {
    executionLogs: types.maybeNull(types.frozen()),
    error: types.maybeNull(types.string)
  })
  .actions((self) => ({
    fetchExecutionLogs(payload) {
      self.error = null;
      Framework.getEventManager().publish(constants.GET_AI_ADMIN_EXECUTION_LOGS, { payload });
    },

    setResponse(data) {
      self.executionLogs = data?.logs || null;
      self.error = null;
      Framework.getEventManager().publish(constants.GET_AI_ADMIN_EXECUTION_LOGS_RESPONSE, {
        logs: self.executionLogs
      });
    },

    setError(error) {
      self.error = error;
      self.executionLogs = null;
      Framework.getEventManager().publish(constants.GET_AI_ADMIN_EXECUTION_LOGS_RESPONSE, {
        logs: null
      });
    },

    clear() {
      self.executionLogs = null;
      self.error = null;
    }
  }));

export default AiAdminExecutionLogsModel;
